export const YasguiOrientation = {
    VERTICAL: 'orientation-vertical',
    HORIZONTAL: 'orientation-horizontal'
};
